import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";

import useSearch from "@/hooks/useSearch";
import useDeleteEntity from "@/hooks/useDeleteEntity";

import PatientsPagination from "@/components/PatientsPagination/PatientsPagination";
import Navigation from "@/components/Navigation/Navigation";
import UsersHeader from "@/components/UsersHeader/UsersHeader";
import ModalDialog from "@/components/ModalDialog/ModalDialog";
import UsersDrawerAddUser from "@/components/UsersDrawerAddUser/UsersDrawerAddUser";
import UsersListing from "@/components/UsersListing/UsersListing";

import { RootState } from "@/store/store";
import { setPatientId } from "@/store/patients/patients";
import { deleteItemFromData } from "@/store/data/dataSlice";
import { setIsVisibleModalDialog } from "@/store/ui/ui";

import "@/shared/styles/layout.scss";

export default function UsersPage() {
    const [query, setQuery] = useState<string>("");
    const [open, setOpen] = useState<boolean>(false);
    const { handleDelete } = useDeleteEntity();
    const dispatch = useDispatch();
    const isEditEntity = false;
    const {
        isLoading,
        activepage,
        handleChangeActivepage,
        limitPage,
        handleChangeSortOpton,
        sortOption,
    } = useSearch("users/searchuser", query);
    const data = useSelector((state: RootState) => state.data.data);
    const doctortId = useSelector(
        (state: RootState) => state.patients.patientId,
    );

    let doctorName = "";

    if (data && data.length > 0 && doctortId) {
        const nameArr = data.filter(item => item._id === doctortId);
        if (nameArr.length > 0) {
            doctorName = nameArr[0].name;
        }
    }
    function toggleDrawer(isOpen: boolean): void {
        setOpen(isOpen);
    }
    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        setQuery(e.target.value);
    }

    const handleDeletePatient = async () => {
        function handleDeletePatientId() {
            dispatch(deleteItemFromData(doctortId));
        }
        await handleDelete({
            entity: "users",
            id: doctortId,
            onSuccess: handleDeletePatientId,
            message: "Користувача успішно видалено",
            isLocalLoading: true,
        });
        dispatch(setPatientId(""));
        dispatch(setIsVisibleModalDialog(false));
    };

    return (
        <div className='container patients_container'>
            <Navigation />
            <UsersHeader
                handleChange={handleChange}
                query={query}
                toggleDrawer={toggleDrawer}
                handleChangeSortOpton={handleChangeSortOpton}
                sortOption={sortOption}
            />
            <main className='main_content_container'>
                <UsersListing isLoading={isLoading} />
                <PatientsPagination
                    activepage={activepage}
                    handleChangeActivepage={handleChangeActivepage}
                    limitPage={limitPage}
                />
                <UsersDrawerAddUser
                    open={open}
                    toggleDrawer={toggleDrawer}
                    isEditEntity={isEditEntity}
                />
                <ModalDialog
                    onConfirm={handleDeletePatient}
                    title='Видалити запис користувача?'
                    message={`Ви впевнені, що хочете видалити користувача ${
                        doctorName ? doctorName : ""
                    }?`}
                />
            </main>
        </div>
    );
}
